import { render, staticRenderFns } from "./MUS006-vistaGerente.vue?vue&type=template&id=5aabe948&"
import script from "./MUS006-vistaGerente.vue?vue&type=script&lang=js&"
export * from "./MUS006-vistaGerente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports